import { getDateFormat } from '@helpers/utils-helpers';
import { DeleteOutlined, ShowOutlined } from '@icon';
import { ListItem, ListItemRightActions, ListItemTitleTagDescription } from '@ui';
import moment from 'moment';
import React from 'react';
import { IMedicalRecord } from 'types/medicalRecord.types';

interface MedicalRecordItemProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'onClick' | 'ref'
  > {
  item: IMedicalRecord;
  providerId?: string;
  userId?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: IMedicalRecord) => void;
  onDelete?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: IMedicalRecord) => void;
}

const MedicalRecordItem = (
  { item, providerId, userId, onClick, onDelete, ...rest }: MedicalRecordItemProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const isMyDocument = item.expertId === userId && providerId === item.providerId;
  const handleClick = (e: React.MouseEvent<any, MouseEvent>) => onClick?.(e, item);
  const handleDelete = (e: React.MouseEvent<any, MouseEvent>) => onDelete?.(e, item);

  const dateOfMedicalRecord = moment(item.dateOfMedicalRecord).format(getDateFormat());
  const uploadDate = moment(item.createdAt).format(getDateFormat());

  return (
    <ListItem
      {...rest}
      ref={ref}
      onClick={handleClick}
      right={
        <ListItemRightActions
          actions={[
            { Icon: ShowOutlined, variant: 'ghost-secondary', onClick: handleClick },
            {
              Icon: DeleteOutlined,
              variant: 'danger-outlined',
              onClick: handleDelete,
              disabled: !isMyDocument,
            },
          ]}
        />
      }
    >
      <ListItemTitleTagDescription
        title={item.name}
        description={
          dateOfMedicalRecord === uploadDate
            ? dateOfMedicalRecord
            : `${moment(item.dateOfMedicalRecord).format(getDateFormat())} / ${moment(
                item.createdAt,
              ).format(getDateFormat())}`
        }
        tags={
          isMyDocument
            ? [{ label: 'Expert', variant: 'accent' }]
            : [{ label: 'Pacient', variant: 'default' }]
        }
      />
    </ListItem>
  );
};

export default React.memo(React.forwardRef(MedicalRecordItem));
